/**
 * Custom element for toggling page language (default vs alternate from metafield).
 * Syncs selection with sessionStorage and body[data-page-lang] for header title switching.
 */
class RoLanguageToggle extends HTMLElement {
  static get STORAGE_KEY() {
    return 'ro-footer-page-lang';
  }

  constructor() {
    super();
    this.radios = [];
    this.boundHandleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.radios = Array.from(this.querySelectorAll('.ro-footer-page-lang-radio'));
    if (this.radios.length === 0) return;

    const initial = this.getLang();
    this.setLang(initial);

    this.radios.forEach((radio) => {
      radio.addEventListener('change', this.boundHandleChange);
    });
  }

  disconnectedCallback() {
    this.radios.forEach((radio) => {
      radio.removeEventListener('change', this.boundHandleChange);
    });
  }

  /**
   * @returns {string} 'default' | 'alternate'
   */
  getLang() {
    try {
      return sessionStorage.getItem(RoLanguageToggle.STORAGE_KEY) || 'default';
    } catch (e) {
      return 'default';
    }
  }

  /**
   * @param {string} lang - 'default' | 'alternate'
   */
  setLang(lang) {
    try {
      sessionStorage.setItem(RoLanguageToggle.STORAGE_KEY, lang);
    } catch (e) {}
    if (document.body) {
      document.body.setAttribute('data-page-lang', lang);
    }
    const targets = this.querySelectorAll('[data-footer-page-lang-target]');
    targets.forEach((el) => {
      const key = el.getAttribute('data-visibility-key');
      if (key) {
        el.classList.toggle('tw-hidden', key !== lang);
      }
    });
    this.radios.forEach((radio) => {
      radio.checked = radio.getAttribute('data-lang') === lang;
    });
  }

  /**
   * @param {Event} e
   */
  handleChange(e) {
    const lang = e.target.getAttribute('data-lang');
    if (lang) this.setLang(lang);
  }
}

customElements.define('ro-language-toggle', RoLanguageToggle);
